/**
 * ToastContainer.jsx
 * CCH Care — Phase 2 — Layer 6
 * Last Modified: 2026-03-26
 *
 * Shows slide-in toast notifications from the top.
 * Max 3 visible, auto-dismiss based on priority.
 */
import { COLORS } from '../../../config/constants';

const PRIORITY_STYLES = {
  urgent:    { bg: COLORS.dangerLight,  border: COLORS.danger,  icon: '🔴' },
  important: { bg: COLORS.warningLight, border: COLORS.warning, icon: '🟡' },
  info:      { bg: COLORS.primaryLight, border: COLORS.primary, icon: '🔵' },
};

export default function ToastContainer({ toasts, onDismiss, onTap }) {
  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 60,
      left: 16,
      right: 16,
      zIndex: 200,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      pointerEvents: 'none',
    }}>
      {toasts.map(toast => {
        const style = PRIORITY_STYLES[toast.priority] || PRIORITY_STYLES.info;
        return (
          <div
            key={toast.toastId}
            role="button"
            tabIndex={0}
            onClick={() => onTap && onTap(toast)}
            onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onTap && onTap(toast)}
            style={{
              background: style.bg,
              border: `1px solid ${style.border}`,
              borderRadius: 10,
              padding: '10px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
              cursor: 'pointer',
              pointerEvents: 'auto',
              animation: 'toastSlide 0.3s ease-out',
            }}
          >
            <span style={{ fontSize: 16 }}>{style.icon}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.text }}>
                {toast.title}
              </div>
              <div style={{ fontSize: 12, color: COLORS.textMuted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {toast.message}
              </div>
            </div>
            <button
              onClick={e => { e.stopPropagation(); onDismiss(toast.toastId); }}
              style={{
                background: 'none', border: 'none',
                color: COLORS.textMuted, fontSize: 16,
                cursor: 'pointer', padding: '4px',
              }}
            >
              ✕
            </button>
          </div>
        );
      })}

      <style>{`
        @keyframes toastSlide {
          from { transform: translateY(-20px); opacity: 0; }
          to   { transform: translateY(0);     opacity: 1; }
        }
      `}</style>
    </div>
  );
}
